var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTeam2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 36.6667C37.3638 36.6667 43.3333 30.6971 43.3333 23.3333C43.3333 15.9695 37.3638 10 30 10C22.6362 10 16.6667 15.9695 16.6667 23.3333C16.6667 30.6971 22.6362 36.6667 30 36.6667Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 70V63.3333C10 59.7971 11.4048 56.4057 13.9052 53.9052C16.4057 51.4048 19.7971 50 23.3333 50H36.6667C40.2029 50 43.5943 51.4048 46.0948 53.9052C48.5952 56.4057 50 59.7971 50 63.3333V70",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3333 36.6667L60 43.3333L73.3333 30",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_130"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTeam2);
export default __webpack_public_path__ + "static/media/icon-team-2.9aac030e03dbdd18b4057d7d7cff22b7.svg";
export { ForwardRef as ReactComponent };